import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { BonusSection } from './components/BonusSection';
import { MidPageCTA } from './components/MidPageCTA';
import { ValueStackSection } from './components/ValueStackSection';
import { ResultsSection } from './components/ResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseSection } from './components/PurchaseSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel - Fresh Install
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', '790333870788238');
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen font-sans" data-id="element-0" data-mp="3dlnt0crbmtwp">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1" data-mp="nuhiqjqwkdut">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=790333870788238&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="nv0wrpdfmi3k" />
      </noscript>

      <UrgencyBar data-id="element-3" data-mp="35gm54lhq9kk" />

      <main data-id="element-4" data-mp="34x29ica5b3w">
        <HeroSection data-id="element-5" data-mp="38kxqn1ac7l9" />
        <PainSection data-id="element-6" data-mp="3uct2xiigokzy" />
        <ProblemSection data-id="element-7" data-mp="3udknzzefn0bz" />
        <SolutionSection data-id="element-8" data-mp="3ubztg9s4bhe4" />
        <IncludesSection data-id="element-9" data-mp="3uevq7us8c00z" />
        <BeforeAfterSection data-id="element-10" data-mp="d4e75xjpjkyt" />
        <BonusSection data-id="element-11" data-mp="d3mn9jzh3bod" />
        <MidPageCTA data-id="element-12" data-mp="d45v27vesjoo" />
        <ValueStackSection data-id="element-13" data-mp="d2bj3j2481wq" />
        <ResultsSection data-id="element-14" data-mp="851l3f0nuhxa" />
        <TestimonialsSection data-id="element-15" data-mp="86mcivrohkqx" />
        <PurchaseSection data-id="element-16" data-mp="83i3nl39q0tx" />

        <section className="py-6 px-4 bg-white" data-id="element-17" data-mp="3gl4srkrrw6lm">
          <div className="max-w-3xl mx-auto text-center" data-id="element-18" data-mp="3glwcnyc0cfw2">
            <p className="text-lg md:text-xl font-semibold text-gray-600 italic" data-id="element-19" data-mp="3bmtjbb5e3y3x">
              Creado por Aula Mater, proyecto educativo enfocado en facilitar el
              trabajo docente
            </p>
          </div>
        </section>

        <GuaranteeSection data-id="element-20" data-mp="3liwl2fwbxuqc" />
      </main>

      <footer className="bg-gray-900 text-gray-400 text-center py-8 px-4" data-id="element-21" data-mp="2xuwtjdr720ap">
        <div className="max-w-3xl mx-auto space-y-3" data-id="element-22" data-mp="2xssgo6bbhqya">
          <p className="text-sm text-gray-300" data-id="element-23" data-mp="2swlgyv9ilbos">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-xs leading-relaxed" data-id="element-24" data-mp="18c6pm8j380h0">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-25" data-mp="13clphus6lm2p" />
    </div>;
}